// extracted by mini-css-extract-plugin
export var label = "_rj-0";
export var link = "_rj-1";